export function prevArrow() {
    return `
        <button type="button" class="slick-prev">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5 19.5L9 12L16.5 4.5"/>
            </svg>
        </button>
    `;
}

export function nextArrow() {
    return `
        <button type="button" class="slick-next">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 4.5L15 12L7.5 19.5"/>
            </svg>
        </button>
    `;
}